// noinspection JSUnusedGlobalSymbols

import type {OnairPlayer} from "./onair.player.ts";
import {app, onair, print} from "./config.ts";
import {audioContext} from "../main.tsx";
import {Api} from "./api.ts";
import type {DaoApp} from "../daos/dao-app.ts";

export class IWSService {
  constructor() {
  }

  get data(): DaoApp {
    return app;
  }

  clock(time: number) : void {
    console.log("IWSService.clock", time);
  }

  postMessageHandler(json: string): void {
    console.log("IWSService.postMessageHandler", json);
    alert(json);
  }

  async needResume() {
    if(audioContext.state !== "running") {
      await audioContext.resume();
    }
    const player = onair.activePlayer;
    if(player) {
      const status = player.status();
      if(!status.isPlaying) {
        await player.resume();
      }
    }
  }

  async logout(reason?: string): Promise<void> {
    try {
      await Api.logout(reason ?? 'unknown', true);
    } catch (e) {
      console.error(e);
    }
  }

  playerFocus(command: string) : void {
    const player: OnairPlayer | null = onair.activePlayer;

    if(player) {
      print("playerFocus exists player: ", player, command);
      switch (command) {
        case 'loss':
          player?.audio.pause();
          break;
        case 'player-resume':
          player?.audio.play().catch(()=>{});
          break;
        case 'gain':
          // 사용자 의도에 따라 재개 여부 결정
          break;
        case 'duck':
          player?.setVolume(0.2, false);
          break;
        case 'becoming-noisy':
          player?.audio.pause();
          break;
        case 'resume':
          player?.resume();
          break;
      }
    }

  }
}

export const wps = new IWSService();